<template>
  <div v-if="circulos.length" class="pb-5">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-12">
          <h2 class="title is-2 has-text-centered">Estadísticas</h2>
        </div>

        <div v-if="sortedCirculos.length" class="column is-12">
          <div class="field">
            <multiselect
              v-model="selectedCirculoOption"
              :options="sortedCirculos"
              track-by="id"
              label="nombre"
              :custom-label="formatCirculo"
              placeholder="Buscar círculo..."
              :allow-empty="false"
              @input="onSelectCirculo"
            />
          </div>

          <!-- NUEVO SELECT DE SOCIOS -->
          <div v-if="selectedCirculoOption && selectedCirculoOption.id !== '*'" class="field mt-4">
            <multiselect
              v-model="selectedSocioOption"
              :options="sortedSocios"
              track-by="id"
              label="nombre"
              :custom-label="formatSocio"
              placeholder="Buscar socio..."
              :allow-empty="true"
              @input="onSelectSocio"
            />
          </div>

          <b-button @click="handleSubmit" type="is-primary" class="my-5" expanded> Enviar </b-button>
        </div>

        <div class="column is-12">
          <div class="columns is-multiline">
            <div class="column is-6">
              <b-field label="Año">
                <b-select v-model="selectedYear" expanded>
                  <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field label="Mes">
                <b-select v-model="selectedMonth" expanded>
                  <option value="">Todos</option>
                  <option v-for="month in monthOptions" :key="month.value" :value="month.value">
                    {{ month.label }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!loading" class="dashboard">
        <div class="columns is-multiline">
          <div class="column is-6 box">
            <div class="chart">
              <apexchart type="bar" :options="compra.options" :series="compra.series" height="350"></apexchart>
            </div>
          </div>
          <div class="column is-6 box">
            <div class="chart">
              <apexchart type="bar" :options="venta.options" :series="venta.series" height="350"></apexchart>
            </div>
          </div>
          <div class="column is-6 box">
            <div class="chart">
              <apexchart type="bar" :options="alianza.options" :series="alianza.series" height="350"></apexchart>
            </div>
          </div>
          <div class="column is-6 box">
            <div class="chart">
              <apexchart type="bar" :options="referencia.options" :series="referencia.series" height="350"></apexchart>
            </div>
          </div>
          <div class="column is-6 box">
            <div class="chart">
              <apexchart type="bar" :options="business.options" :series="business.series" height="350"></apexchart>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-multiline">
        <div class="column is-12 my-5 has-text-centered">
          <b-button type="is-primary" @click="descargarCSV('interacciones')" class="mx-2"> Descargar listado de interacciones </b-button>
          <b-button type="is-info" @click="descargarCSV('socios')" class="mx-2"> Descargar resumen de socios </b-button>
          <b-button type="is-success" @click="descargarCSV('circulos')" class="mx-2"> Descargar resumen de círculos </b-button>
          <b-button type="is-warning" @click="descargarCSV('galardon')" class="mx-2"> Descargar reporte galardón anual </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import VueApexCharts from 'vue-apexcharts';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'Dashboard',
  components: {
    apexchart: VueApexCharts,
    Multiselect,
  },
  data() {
    return {
      loading: false,
      selectedCirculoOption: null,
      selectedSocioOption: null,
      selectedYear: new Date().getFullYear().toString(),
      selectedMonth: '',
    };
  },
  computed: {
    ...mapState({
      circulos: (state) => state.statistics.circulos, // <-- asegúrate que esto exista en tu módulo
      socios: (state) => state.statistics.socios, // <-- asegúrate que esto exista en tu módulo
      compra: (state) => state.statistics.compra,
      venta: (state) => state.statistics.venta,
      alianza: (state) => state.statistics.alianza,
      referencia: (state) => state.statistics.referencia,
      business: (state) => state.statistics.business,
    }),
    sortedCirculos() {
      if (!Array.isArray(this.circulos) || !this.circulos.length) return [];
      const options = [...this.circulos];
      options.unshift({ id: '*', nombre: 'Todos' });
      return options;
    },
    sortedSocios() {
      if (!Array.isArray(this.socios)) return [];
      const list = [...this.socios];
      list.unshift({ id: '*', nombre: 'Todos los socios' });
      return list;
    },
    yearOptions() {
      const current = new Date().getFullYear();
      return [current.toString(), (current - 1).toString(), (current - 2).toString()];
    },
    monthOptions() {
      return [
        { value: '01', label: 'Enero' },
        { value: '02', label: 'Febrero' },
        { value: '03', label: 'Marzo' },
        { value: '04', label: 'Abril' },
        { value: '05', label: 'Mayo' },
        { value: '06', label: 'Junio' },
        { value: '07', label: 'Julio' },
        { value: '08', label: 'Agosto' },
        { value: '09', label: 'Septiembre' },
        { value: '10', label: 'Octubre' },
        { value: '11', label: 'Noviembre' },
        { value: '12', label: 'Diciembre' },
      ];
    },
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.fetchOptions();
    const defaultCirculo = this.sortedCirculos.length ? this.sortedCirculos[0] : null;
    this.selectedCirculoOption = defaultCirculo || null;
    await this.loadAsyncData();
  },
  methods: {
    ...mapActions({
      fetchCharts: 'statistics/fetchCharts',
      fetchOptions: 'statistics/fetchOptions',
    }),
    async onSelectCirculo(option) {
      this.selectedCirculoOption = option || null;
      this.selectedSocioOption = null;
      if (this.selectedCirculoOption && this.selectedCirculoOption.id !== '*') {
        await this.loadSocios();
      }
    },
    onSelectSocio(option) {
      this.selectedSocioOption = option || null;
    },
    async loadSocios() {
      if (!this.selectedCirculoOption) return;
      await this.fetchOptions({ circulo_id: this.selectedCirculoOption.id });
    },
    async loadAsyncData() {
      if (!this.selectedCirculoOption) return;

      this.loading = true;

      const circuloId = this.selectedCirculoOption.id === '*' ? null : this.selectedCirculoOption.id;
      const socioId = this.selectedSocioOption ? (this.selectedSocioOption.id === '*' ? null : this.selectedSocioOption.id) : null;

      await this.fetchCharts({
        circulo_id: circuloId,
        socio_id: socioId,
        year: this.selectedYear,
        month: this.selectedMonth,
      });

      this.loading = false;
    },

    handleSubmit() {
      this.loadAsyncData();
    },

    formatCirculo(option) {
      return option.nombre === 'Todos' || option.id === '*' ? 'TODOS LOS CÍRCULOS' : option.nombre.toUpperCase();
    },

    formatSocio(socio) {
      return socio.nombre === 'Todos los socios' || socio.id === '*'
        ? 'TODOS LOS SOCIOS'
        : socio.empresa + ' - ' + socio.rfc.toUpperCase() + ' - ' + socio.nombre.toUpperCase() + ' ' + socio.apellido.toUpperCase();
    },
    descargarCSV(tipo) {
      const baseUrl = process.env.VUE_APP_API_URL;
      let url = '';

      if (tipo === 'interacciones') {
        url = `${baseUrl}statistics/download_interaction_list`;
      } else if (tipo === 'socios') {
        url = `${baseUrl}statistics/download_socios_list`;
      } else if (tipo === 'circulos') {
        url = `${baseUrl}statistics/download_circulos_list`;
      } else if (tipo === 'galardon') {
        url = `${baseUrl}statistics/download_galardon_report`;
      }

      // Abrir en nueva pestaña
      const paramsObject = {
        year: this.selectedYear,
      };

      if (tipo !== 'galardon') {
        paramsObject.month = this.selectedMonth || '';
        paramsObject.circulo_id = this.selectedCirculoOption && this.selectedCirculoOption.id !== '*' ? this.selectedCirculoOption.id : '';
        paramsObject.socio_id = this.selectedSocioOption && this.selectedSocioOption.id !== '*' ? this.selectedSocioOption.id : '';
      }

      const params = new URLSearchParams(paramsObject);

      window.open(`${url}?${params.toString()}`, '_blank');
    },
  },
};
</script>
